[
    {
        "position": {
            "x": 0,
            "y": 0,
            "z": 0
        },
        "hasCollision": true
    },
    {
        "position": {
            "x": 0,
            "y": 1,
            "z": 0
        },
        "hasCollision": true
    },
    {
        "position": {
            "x": 0,
            "y": 2,
            "z": 0
        }
    },
    {
        "position": {
            "x": 0,
            "y": 3,
            "z": 0
        },
        "hasCollision": true
    },
    {
        "position": {
            "x": 0,
            "y": 4,
            "z": 0
        }
    },
    {
        "position": {
            "x": 0,
            "y": 5,
            "z": 0
        }
    },
    {
        "position": {
            "x": 0,
            "y": 6,
            "z": 0
        }
    },
    {
        "position": {
            "x": 0,
            "y": 7,
            "z": 0
        },
        "hasCollision": true
    },
    {
        "position": {
            "x": 1,
            "y": 0,
            "z": 0
        },
        "hasCollision": true
    },
    {
        "position": {
            "x": 1,
            "y": 1,
            "z": 0
        },
        "hasCollision": true
    },
    {
        "position": {
            "x": 1,
            "y": 2,
            "z": 0
        }
    },
    {
        "position": {
            "x": 1,
            "y": 3,
            "z": 0
        }
    },
    {
        "position": {
            "x": 1,
            "y": 4,
            "z": 0
        }
    },
    {
        "position": {
            "x": 1,
            "y": 5,
            "z": 0
        }
    },
    {
        "position": {
            "x": 1,
            "y": 6,
            "z": 0
        }
    },
    {
        "position": {
            "x": 1,
            "y": 7,
            "z": 0
        }
    },
    {
        "position": {
            "x": 2,
            "y": 0,
            "z": 0
        },
        "isTree": true
    },
    {
        "position": {
            "x": 2,
            "y": 1,
            "z": 0
        }
    },
    {
        "position": {
            "x": 2,
            "y": 2,
            "z": 0
        }
    },
    {
        "position": {
            "x": 2,
            "y": 3,
            "z": 0
        },
        "hasCollision": true
    },
    {
        "position": {
            "x": 2,
            "y": 4,
            "z": 0
        },
        "hasCollision": true
    },
    {
        "position": {
            "x": 2,
            "y": 5,
            "z": 0
        },
        "hasCollision": true
    },
    {
        "position": {
            "x": 2,
            "y": 6,
            "z": 0
        }
    },
    {
        "position": {
            "x": 2,
            "y": 7,
            "z": 0
        },
        "hasCollision": true
    },
    {
        "position": {
            "x": 3,
            "y": 0,
            "z": 0
        }
    },
    {
        "position": {
            "x": 3,
            "y": 1,
            "z": 0
        }
    },
    {
        "position": {
            "x": 3,
            "y": 2,
            "z": 0
        }
    },
    {
        "position": {
            "x": 3,
            "y": 3,
            "z": 0
        },
        "hasCollision": true
    },
    {
        "position": {
            "x": 3,
            "y": 4,
            "z": 0
        }
    },
    {
        "position": {
            "x": 3,
            "y": 5,
            "z": 0
        }
    },
    {
        "position": {
            "x": 3,
            "y": 6,
            "z": 0
        }
    },
    {
        "position": {
            "x": 3,
            "y": 7,
            "z": 0
        }
    },
    {
        "position": {
            "x": 4,
            "y": 0,
            "z": 0
        },
        "hasCollision": true
    },
    {
        "position": {
            "x": 4,
            "y": 1,
            "z": 0
        }
    },
    {
        "position": {
            "x": 4,
            "y": 2,
            "z": 0
        },
        "hasCollision": true
    },
    {
        "position": {
            "x": 4,
            "y": 3,
            "z": 0
        },
        "hasCollision": true
    },
    {
        "position": {
            "x": 4,
            "y": 4,
            "z": 0
        }
    },
    {
        "position": {
            "x": 4,
            "y": 5,
            "z": 0
        }
    },
    {
        "position": {
            "x": 4,
            "y": 6,
            "z": 0
        },
        "isTree": true
    },
    {
        "position": {
            "x": 4,
            "y": 7,
            "z": 0
        }
    },
    {
        "position": {
            "x": 5,
            "y": 0,
            "z": 0
        }
    },
    {
        "position": {
            "x": 5,
            "y": 1,
            "z": 0
        }
    },
    {
        "position": {
            "x": 5,
            "y": 2,
            "z": 0
        }
    },
    {
        "position": {
            "x": 5,
            "y": 3,
            "z": 0
        }
    },
    {
        "position": {
            "x": 5,
            "y": 4,
            "z": 0
        }
    },
    {
        "position": {
            "x": 5,
            "y": 5,
            "z": 0
        }
    },
    {
        "position": {
            "x": 5,
            "y": 6,
            "z": 0
        }
    },
    {
        "position": {
            "x": 5,
            "y": 7,
            "z": 0
        }
    }
]
